export const MEDICATION_FREQUENCIES = [
  "as_needed",
  "once_daily",
  "twice_daily",
  "three_times_daily",
  "weekly",
  "monthly",
] as const;

export type MedicationFrequency = (typeof MEDICATION_FREQUENCIES)[number];

export const FREQUENCY_LABELS: Record<MedicationFrequency, string> = {
  as_needed: "As Needed",
  once_daily: "Once Daily",
  twice_daily: "Twice Daily",
  three_times_daily: "Three Times Daily",
  weekly: "Weekly",
  monthly: "Monthly",
};
